/* eslint-disable no-tabs */
export const goToUrl = (urlPath) => {
  try {
    if (typeof window === 'undefined' || typeof urlPath !== 'string' || !urlPath) {
      throw new Error('Invalid URL provided');
    }
    if (typeof window !== 'undefined') {
      const url = window?.location?.origin + urlPath;
      window.top.location = url;
    }
  } catch (error) {
    console.error('Error navigating to URL:', error);
  }
};

export const getUrlParam = (param) => {
  if (typeof window !== 'undefined') {
    const searchParams = window?.top.location?.search || '';
    const urlParams = new URLSearchParams(searchParams);
    return urlParams.get(param);
  }
  return null;
};

export const getTmxId = () => {
  let nativeTMXID;
  if (typeof window !== 'undefined' && window.__EXPERIENCE_CONTEXT__?.isConsumerApp) {
    nativeTMXID = getUrlParam('guid');
  }
  return nativeTMXID || ((typeof window !== 'undefined') && window.top.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId());
};
